import * as React from 'react'
import Grid from '@mui/material/Grid';
import { Box, Button, CardContent, FormControl, FormControlLabel, Paper, Stack, Switch, TextField, Toolbar, Typography } from '@mui/material';
import { useLoaderData, useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup"
import { defaultApi } from '../../api-interface';
import { useContext } from 'react';
import { TenantContext } from '../..';

export async function loader(register_id, register_secret) {
    try {
        const reg = await defaultApi.getPendingRegistrationPendingRegistrationIdSecretGet(register_id, register_secret)
        const ret = reg.data;
        return ret;
    } catch (e) {
        if (e?.response?.data?.detail) {
            throw new Error(e?.response?.data?.detail)
        }
        throw e
    }


}


const Register = () => {
    const { register_id, register_secret } = useParams();

    const navigate = useNavigate()
    const email = useLoaderData() as string;

    const schema = yup
        .object({
            first_name: yup.string().required("First Name is required").min(2, "First name must be at least two characters"),
            last_name: yup.string().required().min(2),
            password: yup.string().required('Password is required').min(8, "Must Contain 8 Characters")
                .matches(
                    /^(?=.*[a-z])/,
                    " Must Contain One Lowercase Character"
                )
                .matches(
                    /^(?=.*[A-Z])/,
                    "  Must Contain One Uppercase Character"
                )
                .matches(
                    /^(?=.*[0-9])/,
                    "  Must Contain One Number Character"
                )
                .matches(
                    /^(?=.*[!@#\$\-%\^&\*_])/,
                    "  Must Contain One Special Character"
                ),
            password_confirmation: yup.string()
                .oneOf([yup.ref('password')], 'Passwords must match')
        })
        .required()

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    })

    const handleRegisterUser = async (form) => {
        try {
            await defaultApi.registerUserRegisterPost(
                {
                    first_name: form.first_name,
                    last_name: form.last_name,
                    password: form.password,
                    registration_id: register_id!,
                    registration_secret: register_secret!
                }
            )
        } catch (e) {
            if (e?.response?.data?.detail) {
                throw new Error(e?.response?.data?.detail)
            }
            throw e
        }
        navigate("/")
    }


    return (
        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
            <Toolbar />
            <Box display={"flex"} flexDirection={"row"} gap={2} justifyContent={"center"}>
                <Paper elevation={6}>
                    <CardContent>
                        <form onSubmit={handleSubmit(handleRegisterUser)}>
                            <FormControl fullWidth>
                                <Typography align="center" variant="h5">Register</Typography>
                                <TextField
                                    margin="normal"
                                    label="Email Address"
                                    type="text"
                                    variant='outlined'
                                    autoComplete="email"
                                    value={email}
                                    disabled
                                    required
                                />
                                <TextField
                                    margin="normal"
                                    label="First Name"
                                    placeholder="First Name"
                                    {...register('first_name')}
                                    error={errors.first_name ? true : false}
                                    helperText={errors.first_name?.message?.toString()}
                                    type="text"
                                    variant='outlined'
                                    autoComplete="given-name"
                                    required
                                />
                                <TextField
                                    margin="normal"
                                    label="Last Name"
                                    placeholder="Last Name"
                                    {...register('last_name')}
                                    error={errors.last_name ? true : false}
                                    helperText={errors.last_name?.message?.toString()}
                                    type="text"
                                    variant='outlined'
                                    autoComplete="family-name"
                                    required
                                />
                            </FormControl>
                            <FormControl fullWidth>
                                <TextField
                                    margin="normal"
                                    label="Password"
                                    placeholder="Password"
                                    {...register('password')}
                                    error={errors.password ? true : false}
                                    helperText={errors.password?.message?.toString()}
                                    type="password"
                                    autoComplete="new-password"
                                    variant='outlined'
                                    required
                                />
                                <TextField
                                    margin="normal"
                                    label="Password Confirmation"
                                    placeholder="Password Confirmation"
                                    {...register('password_confirmation')}
                                    error={errors.password_confirmation ? true : false}
                                    helperText={errors.password_confirmation?.message?.toString()}
                                    type="password"
                                    autoComplete="new-password"
                                    variant='outlined'
                                    required
                                />
                                <Button variant="contained" type="submit">Register</Button>
                            </FormControl>
                        </form>
                    </CardContent>
                </Paper>
            </Box>
        </Box>

    )
}

export default Register